import PropTypes from 'prop-types';
import DashboardLayout from '../DashboardLayout/DashboardLayout';
import { STORAGE_KEYS } from '@constants';
import { TourProvider } from '@/contexts/TourContext';

const AuthLayout = ({ children }) => {
  const getUserData = () => {
    const userData = localStorage.getItem(STORAGE_KEYS.USER_DATA);
    return userData ? JSON.parse(userData) : null;
  };

  const user = getUserData();

  const getCompanyId = () => {
    try {
      return JSON.parse(localStorage.getItem('companyData') || 'null')?.id ?? null;
    } catch {
      return null;
    }
  };

  const companyId = getCompanyId();

  const getUserRole = () => {
    if (!user) return 'manufacturer';
    
    const roleIdMap = { 
      5: 'manufacturer',  
      2: 'distributor',  
    };
    
    if (user.role_id && roleIdMap[user.role_id]) {
      return roleIdMap[user.role_id];
    }
    
    return 'manufacturer';
  };

  const userRole = getUserRole();
  const userName = user?.name || user?.first_name || user?.user_name || 'User';
  
  const companyName = user?.company_name || 'Your Company';
                     
  const companyLogo = user?.company_logo || user?.companyLogo || null;

  return (
    <TourProvider userId={user?.id} companyId={companyId}>
      <DashboardLayout
        userRole={userRole}
        userName={userName}
        companyName={companyName}
        companyLogo={companyLogo}
      >
        {children}
      </DashboardLayout>
    </TourProvider>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthLayout;
